<template>
  <el-table-column
    prop="copy_receive_date"
    sortable="custom"
    label="Második másolat beérk."
  >
    <template slot-scope="scope">
      {{ scope.row.copy_receive_date }} <span v-if="scope.row.copy_creator_user_name">({{ scope.row.copy_creator_user_name }})</span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'representativeUser.last_name',
};
</script>
